/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierPropertiesHistory
 */
export interface CarrierPropertiesHistory {
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  historyId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  carrierPropertiesId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  invoiceAuditAgent?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  changeType?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierPropertiesHistory
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  bannerMessageTitle?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesHistory
   */
  bannerMessageDescription?: string;
}

/**
 * Check if a given object implements the CarrierPropertiesHistory interface.
 */
export function instanceOfCarrierPropertiesHistory(
  value: object,
): value is CarrierPropertiesHistory {
  return true;
}

export function CarrierPropertiesHistoryFromJSON(
  json: any,
): CarrierPropertiesHistory {
  return CarrierPropertiesHistoryFromJSONTyped(json, false);
}

export function CarrierPropertiesHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierPropertiesHistory {
  if (json == null) {
    return json;
  }
  return {
    historyId: json["historyId"] == null ? undefined : json["historyId"],
    carrierPropertiesId:
      json["carrierPropertiesId"] == null
        ? undefined
        : json["carrierPropertiesId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    invoiceAuditAgent:
      json["invoiceAuditAgent"] == null ? undefined : json["invoiceAuditAgent"],
    changeType: json["changeType"] == null ? undefined : json["changeType"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    updatedBy: json["updatedBy"] == null ? undefined : json["updatedBy"],
    bannerMessageTitle:
      json["bannerMessageTitle"] == null
        ? undefined
        : json["bannerMessageTitle"],
    bannerMessageDescription:
      json["bannerMessageDescription"] == null
        ? undefined
        : json["bannerMessageDescription"],
  };
}

export function CarrierPropertiesHistoryToJSON(
  json: any,
): CarrierPropertiesHistory {
  return CarrierPropertiesHistoryToJSONTyped(json, false);
}

export function CarrierPropertiesHistoryToJSONTyped(
  value?: CarrierPropertiesHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    historyId: value["historyId"],
    carrierPropertiesId: value["carrierPropertiesId"],
    carrierIdentifier: value["carrierIdentifier"],
    invoiceAuditAgent: value["invoiceAuditAgent"],
    changeType: value["changeType"],
    updatedAt: value["updatedAt"],
    updatedBy: value["updatedBy"],
    bannerMessageTitle: value["bannerMessageTitle"],
    bannerMessageDescription: value["bannerMessageDescription"],
  };
}
